import { useMutation } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { PATHS } from '@/common';

export interface UploadExcessContributionFile {
  file_url?: string;
  s3key?: string;
}

export interface UploadExcessContributionFileParams {
  employeeId: number;
  file: File;
}

export const useUploadExcessContributionFileQuery = (
  onSuccess?: (data: UploadExcessContributionFile) => void,
  onError?: (errorMessage?: string) => void
) => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    ({ employeeId, file }: UploadExcessContributionFileParams) => {
      const formData = new FormData();
      formData.append('file', file as Blob);

      return api.post<UploadExcessContributionFile>(
        PATHS.UPLOAD_EXCESS_CONTRIBUTION_FILE,
        // TODO this endpoint is not present in api gateway at the moment.
        // API_URL.TAX_FORMS_EXCESS_CONTRIBUTIONS_FILE_UPLOAD,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          params: {
            'employee-id': employeeId,
          },
        }
      );
    },
    {
      onSuccess: (response) => {
        onSuccess?.(response.data);
      },
      onError: (error) => {
        const errorMessage = _.get(error, 'response.data.elevate_error_message', '') as string;
        onError?.(errorMessage);
      },
    }
  );

  return {
    upload: mutateAsync,
    isLoading,
    isError,
    isSuccess,
  };
};
